(function ($) {
	$(document).ready(function () {


		$(".rotating-text-banner-block .text-rotator").each(function () {

			let this_banner_block = this;

			setTimeout(function (evt) {

				let max_text_item_height = 0;

				$(".rotating-text-item", this_banner_block).each(function () {

					$(this).css("height", "auto");

					if ($(this).outerHeight() > max_text_item_height) {
						max_text_item_height = Math.ceil($(this).outerHeight());
					}

					$(this).css("height", "");

				});

				$(this_banner_block).css("--rotating-window-height", max_text_item_height + "px");

			}, 200);

			setInterval(function (evt) {

				let current_item = $(".rotating-text-item.active", this_banner_block);

				let next_item;

				if (current_item.is(":last-child")) {

					next_item = $(".rotating-text-item:first-child", this_banner_block);

				} else {

					next_item = current_item.next();

				}

				current_item.removeClass("active");

				next_item.addClass("active");

			}, 2500);

		});

	});
})(jQuery);
